import { render, staticRenderFns } from "./WorkHours.vue?vue&type=template&id=5b237bdc&"
import script from "./WorkHours.vue?vue&type=script&lang=ts&"
export * from "./WorkHours.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports